import { Component } from '@verndale/core';
import flatpickr from 'flatpickr';
import { searchAirports, highlightAirports } from '../helpers/search';
import Autocomplete from '../components/Autocomplete';
import { DATE_FORMAT } from '../constants';
import { getAirports } from '../service/oneworld';

class SearchFlightsItem extends Component {
  setupDefaults() {
    this.dom = {
      $type: this.$el.find('.js-serch-flights__type'),
      $form: this.$el.find('.js-search-flights__form'),
      $from: this.$el.find('.js-search-flights__from .autocomplete'),
      $to: this.$el.find('.js-search-flights__to .autocomplete'),
      $departure: this.$el.find('.js-search-flights__departure .field__input'),
      $departureLayer: this.$el.find(
        '.js-search-flights__departure .field-layer'
      ),
      $return: this.$el.find('.js-search-flights__return .field__input'),
      $returnLayer: this.$el.find('.js-search-flights__return .field-layer'),
      $location: this.$el.find('.search-flights__find-lounges .autocomplete'),
      $loungeField: this.$el.find('.search-flights__find-lounges'),
      $RTWField: this.$el.find('.search-flights__round-world'),
      $fields: this.$el.find('.field'),
      $findLoungeUrl: this.$el[0].dataset.findLoungeUrl,
      $searchUrl: this.$el[0].dataset.searchUrl,
      $flightSearchUrl: this.$el[0].dataset.flightSearchUrl,
      $calendarEndpoint: this.$el[0].dataset.checkCalendarDatesUrl,
      $loungeListId: this.$el[0].dataset.loungeListId,
      $passengersOptions: this.$el.find('.search-flights__passengers-option'),
      $cabinSelect: this.$el.find('.search-flights__passengers-cabin-option select'),
      $passengerField: this.$el.find('.search-flights__passengers'),
      $passengerTab: this.$el.find('.search-flights__passengers-selector'),
      $submitButton: this.$el.find('.search-flights__submit'),
      $loading: this.$el.find('.search-flights__loading'),
      $helpMessageDeparture: this.$el.find(
        '.search-flights__help-message-dates--departure'
      ),
      $helpMessageReturn: this.$el.find(
        '.search-flights__help-message-dates--return'
      ),
      $helpInstructions: this.$el.find('.search-flights__help-message-select')
    };

    this.airportsUrl = this.dom.$form.data('airportsUrl');
    this.loungeSearch = false;

    if (this.dom.$type.length) {
      this.dom.$type[0].setAttribute('checked', true);
      this.setType(this.dom.$type[0].value);
    } else {
      this.$el[0].setAttribute('hidden', true);
    }

    this.from = new Autocomplete(this.dom.$from, {
      filter: ::this.filterAirports,
      render: highlightAirports,
      value: ::this.getAirportValue
    });

    this.to = new Autocomplete(this.dom.$to, {
      filter: ::this.filterAirports,
      render: highlightAirports,
      value: ::this.getAirportValue
    });

    if (this.dom.$location[0]) {
      this.location = new Autocomplete(this.dom.$location, {
        filter: ::this.filterAirports,
        render: highlightAirports,
        value: ::this.getAirportValue
      });
    }

    this.createDates();
    this.disableDateInputs();
    this.incrementPassengers();
  }

  addListeners() {
    this.dom.$type.on('change', this.handleType.bind(this));
    this.dom.$form.on('submit', this.handleSubmit.bind(this));
    this.dom.$to.on('focusout', this.checkDatesAvailable.bind(this));
    this.dom.$from.on('focusout', this.checkDatesAvailable.bind(this));
    this.dom.$departureLayer.on('click', this.toggleInstructions.bind(this));
    this.dom.$returnLayer.on('click', this.toggleInstructions.bind(this));
    this.dom.$cabinSelect.on('change', this.setTotalPassengers.bind(this));

    this.dom.$passengerField.on('click', this.togglePassengerTab.bind(this));
    Array.from(this.dom.$passengersOptions).forEach(option => {
      const minus = option.querySelector('.minus');
      const plus = option.querySelector('.plus');
      const input = option.querySelector('.search-flights__passengers-counts');
      minus.addEventListener('click', this.decrementPassengers.bind(this));
      plus.addEventListener('click', this.incrementPassengers.bind(this));
      input.addEventListener('input', this.setTotalPassengers.bind(this));
    });

    document.addEventListener('mousedown', this.handleClickOutside.bind(this));
  }

  handleClickOutside(event) {
    if (
      this.dom.$passengerField[0] &&
      !this.dom.$passengerField[0].contains(event.target)
    ) {
      this.dom.$passengerTab[0].removeAttribute('data-show');
    }
  }

  togglePassengerTab(e) {
    if (e.target.closest('.field__input')) {
      if (this.dom.$passengerTab[0].hasAttribute('data-show')) {
        this.dom.$passengerTab[0].removeAttribute('data-show');
      } else {
        this.dom.$passengerTab[0].setAttribute('data-show', 'true');
      }
    }
  }

  setTotalPassengers() {
    const mainInput = document.querySelector(
      '.search-flights__passengers .field__input'
    );
    const values = Array.from(this.dom.$passengersOptions).map(option => {
      const input = option.querySelector('.search-flights__passengers-counts');
      return Number(input.value);
    });

    const selectedOption = this.dom.$cabinSelect[0].querySelector('option:checked').textContent;
    const valuesSum = values.reduce((a, b) => a + b);
    const valuesString = valuesSum > 1 ? 'Passengers' : 'Passenger';
    mainInput.value = `${valuesSum > 0 ? `${valuesSum} ${valuesString} in ${selectedOption}` : 'Please add a passenger'}  `;
  }

  incrementPassengers(e) {
    if (e) {
      const input = e.target.parentElement.querySelector(
        '.search-flights__passengers-counts'
      );
      input.value = Number(input.value) + 1;
    } else {
      const input = this.$el.find('.search-flights__passengers-counts.adult');
      input[0].value = 1;
    }

    this.setTotalPassengers();
  }

  decrementPassengers(e) {
    const input = e.target.parentElement.querySelector(
      '.search-flights__passengers-counts'
    );

    if (Number(input.value) > 1 && input.classList.contains('adult')) {
      input.value = Number(input.value) - 1;
      this.setTotalPassengers();
    } else if (Number(input.value) > 0 && !input.classList.contains('adult')) {
      input.value = Number(input.value) - 1;
      this.setTotalPassengers();
    }
  }

  createDates() {
    if (this.dom.$departure[0] && this.dom.$return[0]) {
      this.dates = flatpickr(this.dom.$departure[0], {
        dateFormat: DATE_FORMAT,
        disableMobile: true,
        minDate: 'today',
        onChange: this.handleOnChangeDates.bind(this)
      });

      this.datesReturn = flatpickr(this.dom.$return[0], {
        dateFormat: DATE_FORMAT,
        disableMobile: true,
        minDate: 'today'
      });

      if (this.dom.$departure[0]) {
        this.dom.$departure[0].removeAttribute('readonly');
      }
      if (this.dom.$return[0]) {
        this.dom.$return[0].removeAttribute('readonly');
      }
    }
  }

  convertDateFromDatePickr(selectedDate) {
    const dateObj = new Date(selectedDate);
    const month = dateObj.getMonth() > 9 ? dateObj.getMonth() + 1 : `0${dateObj.getMonth() + 1}`; // Months are zero-indexed
    const day = dateObj.getDate() > 9 ? dateObj.getDate() : `0${dateObj.getDate()}`;
    const year = dateObj.getFullYear();

    return `${month}/${day}/${year}`;
  }

  handleOnChangeDates(selectedDates, dateStr, instance) {
    const formattedDate = this.convertDateFromDatePickr(selectedDates[0]);

    if (this.dom.$return[0].value && new Date(formattedDate) >= new Date(this.dom.$return[0].value)) {
      this.datesReturn.setDate(null);
    }

    const currentNewDates = this.returnDates.filter(date => {
      return new Date(date) >= new Date(formattedDate);
    });

    this.datesReturn.set('enable', currentNewDates);
    this.datesReturn.jumpToDate(currentNewDates[0]);
  }

  async filterAirports(value) {
    if (!value || value.length < 2) {
      return [];
    }

    const airports = await getAirports({ url: this.airportsUrl });

    return searchAirports(airports, value);
  }

  getAirportValue(item) {
    return `${item.item.Name}`;
  }

  handleType(e) {
    const type = e.currentTarget.value;
    this.setType(type);
  }

  handleSubmit(e) {
    e.preventDefault();
    if (this.props.onSearch) {
      const data = this.getData();
      this.props.onSearch(data);
    } else {
      this.submitRedirect();
    }
  }

  createArray(number, age) {
    return Array.from({ length: Number(number) }, (_, i) => age);
  }

  buildUrl(data) {
    const { location, from, to, departureDate, returnDate } = data;

    let url = '';
    if (location) {
      const listId = this.dom.$loungeListId ? `#${this.dom.$loungeListId}` : '';
      url = `${this.dom.$findLoungeUrl}?location=${location}${listId}`;
    }
    if (from && to && departureDate) {
      const adult = document.querySelector('.adult');
      const children = document.querySelector('.children');
      const infant = document.querySelector('.infant');
      const cabinValue = this.dom.$cabinSelect[0].value;

      url = `${
        this.dom.$flightSearchUrl
      }?utm_source=oneworld_picker&origins=${from}&destinations=${to}&departureDate=${departureDate}&returnDate=${returnDate}&isOneWay=${
        returnDate !== '' && returnDate ? false : true
      }&adult=${
        adult.value ? this.createArray(adult.value, 18).join(',') : ''
      }&child=${
        children.value ? this.createArray(children.value, 17).join(',') : ''
      }&infant=${
        infant.value ? this.createArray(infant.value, 0).join(',') : ''
      }&cabinClass=${cabinValue ? cabinValue : ''}`;
    }
    return url;
  }

  submitRedirect() {
    const data = this.getData();
    const redirectUrl = this.buildUrl(data);
    if (redirectUrl) window.location.href = redirectUrl;
  }

  async findItemByCode(code) {
    const airports = await getAirports({ url: this.airportsUrl });
    return airports.find(item => item.Code === code);
  }

  showElements(el) {
    if (el) {
      if (el.length) {
        Array.from(el).forEach(field => {
          if (field.hasAttribute('hidden')) {
            field.removeAttribute('hidden');
          }
        });
      } else {
        el.removeAttribute('hidden');
      }
    }
  }

  hideElements(el) {
    if (el) {
      if (el.length) {
        Array.from(el).forEach(field => {
          field.setAttribute('hidden', 'true');
        });
      } else {
        el.setAttribute('hidden', 'true');
      }
    }
  }

  setRequiredField(el) {
    if (el) {
      if (el.length) {
        Array.from(el).forEach(field => {
          field.querySelector('input').setAttribute('required', 'true');
        });
      } else {
        el.setAttribute('required', 'true');
      }
    }
  }

  removeRequiredField(el) {
    if (el) {
      if (el.length) {
        Array.from(el).forEach(field => {
          field.querySelector('input').removeAttribute('required');
        });
      } else {
        el.removeAttribute('required');
      }
    }
  }

  setLoungeSearch(value) {
    this.loungeSearch = value;
  }

  setType(type) {
    this.type = type;
    if (this.dates) {
      const selectedDates = [...this.dates.selectedDates];
      this.dates.destroy();
      this.createDates();
      this.dates.setDate(selectedDates[0]);
      this.checkDatesAvailable();
    }

    switch (type) {
    case 'one-way':
      this.$el.addClass('one-way');
      this.$el.removeClass('round-trip');
      this.showElements(this.dom.$fields);
      this.showElements(this.dom.$submitButton[0]);
      this.hideElements(this.dom.$loungeField[0]);
      this.hideElements(this.dom.$RTWField[0]);
      this.showElements(this.dom.$passengerField[0]);
      this.setRequiredField(
        this.dom.$passengerField[0].querySelector('input')
      );
      this.setRequiredField(this.dom.$departure[0]);
      this.removeRequiredField(this.dom.$return[0]);
      this.removeRequiredField(
        this.dom.$loungeField[0].querySelector('input')
      );
      this.setLoungeSearch(false);
      break;
    case 'round-trip':
      this.$el.addClass('round-trip');
      this.$el.removeClass('one-way');
      this.showElements(this.dom.$fields);
      this.showElements(this.dom.$submitButton[0]);
      this.hideElements(this.dom.$loungeField[0]);
      this.hideElements(this.dom.$RTWField[0]);
      this.showElements(this.dom.$passengerField[0]);
      this.setRequiredField(this.dom.$return[0]);
      this.setRequiredField(this.dom.$departure[0]);
      this.setRequiredField(
        this.dom.$passengerField[0].querySelector('input')
      );
      this.removeRequiredField(
        this.dom.$loungeField[0].querySelector('input')
      );
      this.setLoungeSearch(false);
      break;
    case 'find-lounge':
      this.hideElements(this.dom.$fields);
      this.showElements(this.dom.$loungeField[0]);
      this.showElements(this.dom.$submitButton[0]);
      this.hideElements(this.dom.$RTWField[0]);
      this.hideElements(this.dom.$passengerField[0]);
      this.removeRequiredField(this.dom.$fields);
      this.removeRequiredField(
        this.dom.$passengerField[0].querySelector('input')
      );
      this.setRequiredField(this.dom.$loungeField[0].querySelector('input'));
      this.setLoungeSearch(true);
      break;
    case 'round-world':
      this.hideElements(this.dom.$fields);
      this.hideElements(this.dom.$loungeField[0]);
      this.showElements(this.dom.$RTWField[0]);
      this.hideElements(this.dom.$passengerField[0]);
      this.hideElements(this.dom.$submitButton[0]);
      this.removeRequiredField(this.dom.$fields);
      this.removeRequiredField(
        this.dom.$passengerField[0].querySelector('input')
      );
      this.removeRequiredField(
        this.dom.$loungeField[0].querySelector('input')
      );
      this.setLoungeSearch(false);
      break;
    default:
      this.$el.addClass('one-way');
      this.$el.removeClass('round-trip');
      this.showElements(this.dom.$fields);
      this.hideElements(this.dom.$loungeField[0]);
      this.setLoungeSearch(false);
    }
  }

  setRoundTrip() {
    this.dom.$type.filter('[value="round-trip"]').attr('checked', true);
    this.setType('round-trip');
  }

  async setFrom(from) {
    const item = await this.findItemByCode(from);
    this.from.setSelectedItem({ item });
  }

  async setTo(to) {
    const item = await this.findItemByCode(to);
    this.to.setSelectedItem({ item });
  }

  setDates(departureDate, returnDate) {
    const dates = [];
    if (departureDate) {
      const departureDateObj = flatpickr.parseDate(departureDate, DATE_FORMAT);
      dates.push(departureDateObj);
    }
    if (returnDate) {
      const returnDateObj = flatpickr.parseDate(returnDate, DATE_FORMAT);
      dates.push(returnDateObj);
    }
    this.dates.setDate(dates);
    this.dom.$departure.val(departureDate || '');
    this.dom.$return.val(returnDate || '');
  }

  getData() {
    const data = {};
    if (!this.loungeSearch) {
      const fromItem = this.from.getSelectedItem();
      const toItem = this.to.getSelectedItem();
      const departureDate = this.dom.$departure.val();
      const returnDate = this.dom.$return.val();

      if (fromItem) {
        data.from = fromItem.Code;
      }
      if (toItem) {
        data.to = toItem.Code;
      }
      if (departureDate) {
        data.departureDate = departureDate;
        data.departureDateObj = this.dates.selectedDates[0];
      }
      if (returnDate) {
        data.returnDate = returnDate;
        data.returnDateObj = this.dates.selectedDates[1];
      }
    } else {
      const locationItem = this.location.getSelectedItem();

      if (locationItem) {
        data.location = locationItem.Code;
      }
    }
    return data;
  }

  async fetchAvailableDates(origin, destination, isDeparture) {
    this.dom.$loading.addClass('loading');
    this.dom.$loading.find('.spinner').addClass('is-active');

    // use this urls for testing
    // const urlGoing = `https://private-662090-oneworldapi1.apiary-mock.com/travel-dates-go?origin=${origin}&destination=${destination}`;
    // const urlBack = `https://private-662090-oneworldapi1.apiary-mock.com/travel-dates-return?origin=${origin}&destination=${destination}`;
    // isDeparture ? urlGoing : urlBack
    // eslint-disable-next-line no-undef
    return fetch(
      `${this.dom.$calendarEndpoint}?origin=${origin}&destination=${destination}`
    )
      .then(response => response.json())
      .then(data => {
        if (data.dates) {
          this.dom.$loading.removeClass('loading');
          this.dom.$loading.find('.spinner').removeClass('is-active');
          return data.dates;
        }
      });
  }

  convertDateFormat(datesArray) {
    return datesArray.map(date => {
      const dateArray = date.split('-');
      return `${dateArray[1]}/${dateArray[2]}/${dateArray[0]}`;
    });
  }

  async checkDatesAvailable() {
    this.disableDateInputs();

    const data = new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(this.getData());
      }, 500);
    });

    const results = await data;

    if (results) {
      if (this.type === 'one-way') {
        if (results.from && results.to) {
          this.departureDates = await this.fetchAvailableDates(
            results.from,
            results.to,
            true
          );

          if (await this.departureDates) {
            this.departureDates = this.convertDateFormat(this.departureDates);

            this.dates.set('enable', this.departureDates);
            this.enableDateInputs();
          }
        }
      } else if (this.type === 'round-trip') {
        if (results.from && results.to) {
          this.departureDates = await this.fetchAvailableDates(
            results.from,
            results.to,
            true
          );
          this.returnDates = await this.fetchAvailableDates(
            results.to,
            results.from,
            false
          );

          if (await this.returnDates) {
            this.departureDates = this.convertDateFormat(this.departureDates);
            this.returnDates = this.convertDateFormat(this.returnDates);

            this.dates.set('enable', this.departureDates);
            this.datesReturn.set('enable', this.returnDates);
            this.enableDateInputs();
          }
        }
      }
    }
  }

  disableDateInputs() {
    const departureInput = this.dom.$departure[0];
    const returnInput = this.dom.$return[0];
    const fromInput = this.dom.$from.find('input')[0];
    const toInput = this.dom.$to.find('input')[0];
    if (this.type === 'one-way' && this.dom.$departure[0]) {
      departureInput.setAttribute('disabled', true);
    } else if (this.type === 'round-trip' && this.dom.$departure[0] && this.dom.$return[0]) {
      departureInput.setAttribute('disabled', true);
      returnInput.setAttribute('disabled', true);
    }
    if (!fromInput.value || !toInput.value) {
      if (this.dom.$departureLayer[0]) {
        this.dom.$departureLayer[0].removeAttribute('hidden');
      }
      if (this.dom.$returnLayer[0]) {
        this.dom.$returnLayer[0].removeAttribute('hidden');
      }
    }
  }

  enableActions(input, layer) {
    input.removeAttribute('disabled');
    layer.setAttribute('hidden', 'true');
  }

  disableActions(input, layer) {
    input.setAttribute('disabled', true);
    layer.removeAttribute('hidden');
  }

  enableDateInputs() {
    const departureInput = this.dom.$departure[0];
    const returnInput = this.dom.$return[0];

    if (this.type === 'one-way') {
      if (this.departureDates.length) {
        this.enableActions(departureInput, this.dom.$departureLayer[0]);
        this.hideHelpDeparture();
      } else {
        this.disableActions(departureInput, this.dom.$departureLayer[0]);
        this.showHelpDeparture();
      }
    } else if (this.type === 'round-trip') {
      if (this.departureDates.length) {
        this.enableActions(departureInput, this.dom.$departureLayer[0]);
        this.hideHelpDeparture();
      } else {
        this.disableActions(departureInput, this.dom.$departureLayer[0]);
        this.showHelpDeparture();
      }

      if (this.returnDates.length) {
        this.enableActions(returnInput, this.dom.$returnLayer[0]);
        this.hideHelpReturn();
      } else {
        this.disableActions(returnInput, this.dom.$returnLayer[0]);
        this.showHelpReturn();
      }
    }
  }

  showHelpDeparture() {
    this.dom.$helpMessageDeparture[0].removeAttribute('hidden');
  }

  showHelpReturn() {
    this.dom.$helpMessageReturn[0].removeAttribute('hidden');
  }

  hideHelpDeparture() {
    this.dom.$helpMessageDeparture[0].setAttribute('hidden', true);
  }

  hideHelpReturn() {
    this.dom.$helpMessageReturn[0].setAttribute('hidden', true);
  }

  toggleInstructions(e) {
    const target = e.currentTarget.parentElement.querySelector('input');
    const from = this.dom.$from.find('input')[0];
    const to = this.dom.$to.find('input')[0];

    if (target && target.value) {
      return;
    }
    if (!from.value || !to.value) {
      this.dom.$helpInstructions[0].removeAttribute('hidden');
      setTimeout(() => {
        this.dom.$helpInstructions[0].setAttribute('hidden', true);
      }, 5000);
    }
  }
}

export default SearchFlightsItem;
